export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20warm%20gradient%20background%20with%20flowing%20curves%20and%20organic%20shapes%20in%20deep%20coral%20red%20and%20dark%20warm%20tones%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20lighting%20with%20soft%20glow%20effects%2C%20modern%20streaming%20platform%20aesthetic%2C%20no%20text%2C%20no%20logos%2C%20abstract%20art%20style&width=1800&height=900&seq=bbtv-hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-300/40 mb-5 md:mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-xs md:text-sm font-medium text-accent-100 whitespace-nowrap">全网热门影视一站畅享</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-white leading-tight tracking-tight">
              棒棒TV · <span className="text-accent-400">免费高清在线观看</span>
            </h1>

            <p className="mt-3 md:mt-4 text-lg md:text-xl lg:text-2xl font-heading font-semibold text-white/90">
              不卡顿，免缓冲，流畅播放
            </p>

            <p className="mt-5 md:mt-6 text-sm md:text-base text-white/75 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              棒棒TV汇聚海量电视剧全集、电影大片与最新剧集，致力于为观众提供流畅丝滑的高清观影体验。
              每日同步更新热门内容，界面简洁无广告干扰，无论追剧还是补番，都能在这里找到属于你的那块屏幕。
              新剧热综第一时间上线，经典老片随时重温，让好内容不再等待。
            </p>

            <div className="mt-6 md:mt-7 flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/20">
                  <i className="ri-movie-2-line text-accent-400 text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-white/80 whitespace-nowrap">每日更新 50+ 剧集</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/20">
                  <i className="ri-shield-check-line text-accent-400 text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-white/80 whitespace-nowrap">安全无广告 纯净观影</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/20">
                  <i className="ri-device-line text-accent-400 text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-white/80 whitespace-nowrap">手机电脑平板全覆盖</span>
              </div>
            </div>

            <div className="mt-8 md:mt-9 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="whitespace-nowrap w-full sm:w-auto px-7 py-3 rounded-full bg-primary-500 text-background-50 font-heading font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-200 cursor-pointer text-center"
              >
                <i className="ri-play-circle-fill mr-2"></i>立即开始观看
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="whitespace-nowrap w-full sm:w-auto px-7 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white font-heading font-medium text-sm md:text-base border border-white/25 hover:bg-white/25 transition-all duration-200 cursor-pointer text-center"
              >
                <i className="ri-fire-line mr-2"></i>查看热播榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none flex items-center justify-center">
            <div className="relative w-full aspect-[4/3] max-w-[480px]">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20streaming%20entertainment%20visual%20with%20floating%20film%20frames%20and%20play%20buttons%20in%20warm%20coral%20and%20amber%20tones%2C%20modern%20clean%20composition%20with%20soft%20glowing%20accents%2C%20abstract%20geometric%20shapes%20representing%20media%20content%2C%20dark%20background%20with%20vibrant%20color%20pops%2C%20tech%20entertainment%20aesthetic&width=960&height=720&seq=bbtv-hero-visual&orientation=landscape"
                alt="棒棒TV高清影视平台主视觉"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}